import { render, staticRenderFns } from "./AberrationAttachmentsCard.vue?vue&type=template&id=63e6724c"
import script from "./AberrationAttachmentsCard.vue?vue&type=script&lang=ts"
export * from "./AberrationAttachmentsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports